class APIS {
	apis() {
		return {
			get_active_complain: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/active/complaints'
			},
			get_resolved_complain: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/resolved/complaints'
			},
			update_complain: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/update/complaint'
			},
			fetch_metadata: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/complaint/metadata'
			},
			create_metadata: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/complaint/metadata'
			},
			update_metadata: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/update/complaint/metadata'
			},
			search_ticket: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/search/complaint'
			},
			fetch_report: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/ticket/report'
			}
		};
	}
}

export default new APIS();
